import type { CourseDraftSectionsItemLecturesItem } from './courseDraftSectionsItemLecturesItem';

/**
 * 코스 섹션 정보
 */
export type CourseDraftSectionsItem = {
  /**
   * 섹션 ID (새 섹션의 경우 null)
   * @nullable
   */
  id?: string | null;
  /**
   * 섹션에 포함된 강의 목록
   * @nullable
   */
  lectures?: CourseDraftSectionsItemLecturesItem[] | null;
  /**
   * 섹션 순서 (1부터 시작)
   * @minimum 1
   */
  order: number;
  /**
   * 섹션 제목
   * @minLength 1
   * @maxLength 100
   */
  title: string;
};
